"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPrinter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconPrinter = function IconPrinter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.5 3v4.5H21A1.5 1.5 0 0122.5 9v7.5A1.5 1.5 0 0121 18h-1.5v3a1.5 1.5 0 01-1.5 1.5H6A1.5 1.5 0 014.5 21v-3H3a1.5 1.5 0 01-1.5-1.5V9A1.5 1.5 0 013 7.5h1.5V3A1.5 1.5 0 016 1.5h12A1.5 1.5 0 0119.5 3zM18 13.5H6V21h12v-7.5zM16.5 18v1.5h-9V18h9zm0-3v1.5h-9V15h9zM18 9h-3v1.5h3V9zm0-6H6v4.5h12V3z"
  }));
};
exports.IconPrinter = IconPrinter;